import { render } from "./deletlogs.vue?vue&type=template&id=54ebf58e"
import script from "./deletlogs.vue?vue&type=script&lang=js"
export * from "./deletlogs.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__